import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const BuySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M6.725 21q-.75 0-1.3-.5t-.675-1.225L3 7h3V5q0-.825.588-1.413T8 3h8q.825 0 1.413.588T18 5v2h3l-1.75 12.275q-.125.725-.687 1.225t-1.313.5zM5.3 9l1.425 10h10.55L18.7 9zm5.65 8l4.95-4.95l-1.425-1.4l-3.525 3.525l-1.425-1.425L8.1 14.175zM8 7h8V5H8zm4 7"
    ></path>
  </svg>
);
const BuyIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BuySvg} {...props} />
);
export default BuyIcon;
